/**
 * Profiler Provider
 * Provides React Profiler wrapper for the entire application
 * Only active in development environment
 */

import { ReactNode } from "react";
import { ProfilerWrapper } from "@/shared/components/profiler";

interface ProfilerProviderProps {
  children: ReactNode;
}

/**
 * ProfilerProvider - Wraps the entire app with React.Profiler
 * Only active in development environment
 */
export const ProfilerProvider = ({ children }: ProfilerProviderProps) => {
  const isDev = import.meta.env.DEV;

  if (!isDev) {
    return <>{children}</>;
  }

  return (
    <ProfilerWrapper id="AppRoot" enabled={true}>
      {children}
    </ProfilerWrapper>
  );
};
